export default {
	search: 'Search',
	apply_booklet: 'Show Directory Applicitions',
	apply: 'apply',
	applied_booklet: 'Applied Show Directory Info',
	booklet_config: 'Shows the Show Directory note here',
	boothNo:'boothNo',
	company_name: 'companyName',
	en_company_name: 'English CompanyName',
	contactPerson: 'contactPerson',
	phone: 'phone',
	email: 'email',
	address: 'Chinese Address',
	englishAddress: 'English Address',
	apply_date: 'date of applying',
	action: 'Action',
	modify_booklet: 'modify',
	cn_company_name: 'Chinese CompanyName',
	form_title: 'Fill in the Show Directory information',
	form_postCode: 'postCode',
	form_remarks: 'Remarks',
	form_en_remarks: 'English Remarks',
	form_tips: 'If the booth number is not found or the exhibitor information does not match the exhibitor information, please be sure to confirm with the home service staff.',
	form_save: 'submit',
	form_cancel: 'cancel',
	form_boothNo_check: 'please enter the boothNo',
	form_boothNo_check_new: 'The booth number may contain special symbols: underscore (_) or middle dash (-). Please enter the complete booth number',
	"保险码校验信息": "please enter the insuranceNo",
	form_cn_company_name_check: 'please enter the Chinese CompanyName',
	form_en_company_name_placeholder: 'please enter the English CompanyName',
	form_address_placeholder: 'please enter the Chinese Address',
	form_en_address_placeholder: 'please enter the English Address',
	form_contactPerson_check: 'please enter the contactPerson',
	form_phone_placeholder: 'please enter the phone',
	form_phone_check: 'please enter the correct phone number',
	form_email_placeholder: 'please enter the email',
	form_email_check: 'please enter the correct email',
	form_postCode_placeholder: 'please enter the postcode',
	form_remarks_placeholder: 'please enter the remark',
	form_en_remarks_placeholder: 'please enter the English remark',
	loding: 'loading...',
	action_success: 'Success!',
	request_error: 'Request Data Error!',
	'会刊申请截止提醒':'Application notice of Journal',
	'会刊申请截止时间':"It's the deadline for the application of conference journals. No further application is allowed"
	

}



// WEBPACK FOOTER //
// ./src/i18n/en-us/booklet.js